var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalendarGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90.384,
    height: 90.414,
    viewBox: "0 0 90.384 90.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_923",
    "data-name": "Rectangle 923",
    width: 90.384,
    height: 90.414,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3815",
    "data-name": "Group 3815",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2504",
    "data-name": "Group 2504",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2621",
    "data-name": "Path 2621",
    d: "M90.384,59.627A3.678,3.678,0,0,1,87,62.155a3.492,3.492,0,0,1-3.729-3.666q-.007-18.211,0-36.421A7.587,7.587,0,0,0,80.632,15.8a7.716,7.716,0,0,0-4.746-1.613c-1.115-.053-2.235.015-3.35-.022-.635-.021-.818.246-.8.838.032.94.022,1.881,0,2.822a3.588,3.588,0,0,1-7.167-.017c-.019-.97-.023-1.94,0-2.91.012-.529-.192-.729-.724-.728q-7.231.017-14.463,0c-.588,0-.772.232-.756.788.027.94.019,1.881,0,2.822a3.587,3.587,0,0,1-7.17-.01q-.024-1.455,0-2.91c.008-.485-.182-.686-.675-.685q-7.187.012-14.375,0c-.542,0-.725.22-.714.739.022.969.02,1.94,0,2.91a3.588,3.588,0,0,1-7.167,0c-.02-.97-.008-1.94-.006-2.91,0-.379-.026-.725-.535-.724a22.443,22.443,0,0,0-5.44.275C9.159,15.3,7.19,18.062,7.184,21.9q-.018,11.42,0,22.84,0,15.257.006,30.513A8.584,8.584,0,0,0,7.941,79.2c1.45,2.875,3.924,4,7,4q15.433.02,30.866,0,14.816,0,29.631,0a7.506,7.506,0,0,0,6.3-2.751,8.123,8.123,0,0,0,1.518-4.339,3.624,3.624,0,0,1,2.861-3.454,3.669,3.669,0,0,1,4.108,2.178c.054.1.105.21.158.315v3.175c-.045.169-.1.337-.132.509a14.388,14.388,0,0,1-14.124,11.58c-20.608-.085-41.217-.032-61.826-.029a16.574,16.574,0,0,1-2.719-.191A14.165,14.165,0,0,1,.007,76.628Q-.012,48.67,0,20.711a9.574,9.574,0,0,1,.043-1.233A14.175,14.175,0,0,1,14.342,6.991c1.027.038,2.06-.042,3.086.02.824.05,1.2-.183,1.109-1.068-.065-.61.028-1.237-.02-1.85A3.8,3.8,0,0,1,21.055,0h2.117A3.8,3.8,0,0,1,25.711,4.09c-.051.672.034,1.354-.019,2.026-.056.723.254.895.925.892q6.963-.033,13.927,0c.671,0,.981-.169.925-.892-.053-.672.032-1.354-.019-2.026A3.8,3.8,0,0,1,43.988,0h2.117A3.8,3.8,0,0,1,48.644,4.09c-.051.672.034,1.354-.019,2.026-.056.723.254.895.925.892q7.051-.033,14.1,0c.671,0,.981-.169.925-.892-.053-.672.032-1.354-.019-2.026A3.8,3.8,0,0,1,67.1,0h2.117a3.8,3.8,0,0,1,2.54,4.081c-.053.7.021,1.409-.017,2.112-.033.619.216.825.822.811,1.349-.03,2.7-.017,4.049-.006a13.6,13.6,0,0,1,9.126,3.578,14.575,14.575,0,0,1,4.649,8.476Z",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2623",
    "data-name": "Path 2623",
    d: "M70.513,128.037a3.588,3.588,0,1,1,3.582-3.549,3.5,3.5,0,0,1-3.582,3.549",
    transform: "translate(-48.394 -87.404)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2624",
    "data-name": "Path 2624",
    d: "M129.536,124.489a3.588,3.588,0,1,1-3.5-3.628,3.5,3.5,0,0,1,3.5,3.628",
    transform: "translate(-88.488 -87.403)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2625",
    "data-name": "Path 2625",
    d: "M181.388,120.862a3.588,3.588,0,1,1-3.587,3.545,3.5,3.5,0,0,1,3.587-3.545",
    transform: "translate(-128.58 -87.404)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2626",
    "data-name": "Path 2626",
    d: "M236.75,128.037a3.589,3.589,0,1,1,3.666-3.465,3.5,3.5,0,0,1-3.666,3.465",
    transform: "translate(-168.673 -87.403)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2627",
    "data-name": "Path 2627",
    d: "M70.5,183.479a3.588,3.588,0,1,1,3.6-3.535,3.5,3.5,0,0,1-3.6,3.535",
    transform: "translate(-48.394 -127.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2628",
    "data-name": "Path 2628",
    d: "M125.907,183.478a3.588,3.588,0,1,1,3.628-3.5,3.5,3.5,0,0,1-3.628,3.5",
    transform: "translate(-88.487 -127.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2629",
    "data-name": "Path 2629",
    d: "M74.1,235.325a3.588,3.588,0,1,1-3.549-3.582,3.5,3.5,0,0,1,3.549,3.582",
    transform: "translate(-48.395 -167.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2630",
    "data-name": "Path 2630",
    d: "M129.536,235.323a3.588,3.588,0,1,1-3.552-3.58,3.5,3.5,0,0,1,3.552,3.58",
    transform: "translate(-88.488 -167.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2823",
    "data-name": "Path 2823",
    d: "M181.388,120.862a3.588,3.588,0,1,1-3.587,3.545,3.5,3.5,0,0,1,3.587-3.545",
    transform: "translate(-128.579 -72.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2824",
    "data-name": "Path 2824",
    d: "M236.75,128.037a3.589,3.589,0,1,1,3.666-3.465,3.5,3.5,0,0,1-3.666,3.465",
    transform: "translate(-168.676 -72.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2825",
    "data-name": "Path 2825",
    d: "M181.388,120.862a3.588,3.588,0,1,1-3.587,3.545,3.5,3.5,0,0,1,3.587-3.545",
    transform: "translate(-128.579 -57.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2826",
    "data-name": "Path 2826",
    d: "M236.75,128.037a3.589,3.589,0,1,1,3.666-3.465,3.5,3.5,0,0,1-3.666,3.465",
    transform: "translate(-168.676 -57.157)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarGray);
export default __webpack_public_path__ + "static/media/icon_calendar_gray.4e646f984b4d830d40805dbee7a694d1.svg";
export { ForwardRef as ReactComponent };